export default __webpack_public_path__ + "media/images/landing-24-550x420-96835180872edda05cbc63cb8413c34c.jpg";